import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ClaimYourFreeInspection from "./sections/ClaimYourFreeInspection";
import VisitOurJeffersonHq from "./sections/VisitOurJeffersonHq";
import Footer from "./sections/Footer";
import Trustbadges from "./sections/Trustbadges";
export default function ContactPage() {
  return <div>
      <Header />
      <ClaimYourFreeInspection />
      <Trustbadges />
      <VisitOurJeffersonHq />
      <Footer />
    </div>;
}